import Layout from '@/layout'

export default {
  path: '/marketService',
  component: Layout,
  name: 'marketService',
  meta: {
    title: '服务市场',
    role: 1638,
    icon: 'shop'
  },
  children: [
    {
      path: 'shopFix',
      component: () => import('@/pages/marketService/shopFix'),
      name: 'shopFix',
      meta: { title: '店铺装修', role: 1639 }
    },
    {
      path: 'discount',
      component: () => import('@/pages/marketService/discount'),
      name: 'discount',
      meta: { title: '定向优惠', role: 2721 }
    },
    {
      path: 'qd',
      name: 'serve-qd',
      component: () => import('@/pages/serve/qd'),
      meta: { title: 'QQ营销', role: 1648 }
    },
    {
      path: 'apply',
      name: 'qd-apply',
      component: () => import('@/pages/serve/qd-apply'),
      hidden: true,
      meta: { title: '申请开通企点QQ', role: 1649, hidden: true }
    }
  ]
}
